import { DomainError } from "@econ-v1/domain";
import { RESET_LOCAL_STORAGE_CONFIRMATION, } from "@econ-v1/ports";
export class StorageRecoveryCommandDispatcher {
    storage;
    fallback;
    onReady;
    lifecycle;
    constructor(storage, fallback = undefined, onReady = undefined, lifecycle = undefined) {
        this.storage = storage;
        this.fallback = fallback;
        this.onReady = onReady;
        this.lifecycle = lifecycle;
    }
    async execute(name, payload) {
        switch (name) {
            case "client-storage.state.v1": {
                exactRecord(payload, []);
                return json(await this.storage.recoveryState());
            }
            case "client-storage.retry.v1": {
                exactRecord(payload, []);
                const state = await this.#runRecoveryAction("retry", async () => await this.storage.retry());
                await this.#activateWhenReady(state, "retry");
                return json(state);
            }
            case "client-storage.export-diagnostic.v1": {
                const input = exactRecord(payload, ["passphrase"]);
                return json(await this.storage.exportEncryptedDiagnostic({
                    passphrase: stringField(input, "passphrase"),
                }));
            }
            case "client-storage.reset.v1": {
                const input = exactRecord(payload, ["confirmation"]);
                const confirmation = stringField(input, "confirmation");
                if (confirmation !== RESET_LOCAL_STORAGE_CONFIRMATION) {
                    throw new TypeError("Local storage reset confirmation does not match");
                }
                const state = await this.#runRecoveryAction("reset", async () => (await this.storage.reset({ confirmation })));
                await this.#activateWhenReady(state, "reset");
                return json(state);
            }
            default:
                if (this.fallback !== undefined)
                    return await this.fallback.execute(name, payload);
                throw new DomainError({ code: "not_found", message: "Host command is not registered" });
        }
    }
    async #activateWhenReady(state, action) {
        await this.onReady?.(action, state);
    }
    async #runRecoveryAction(action, operation) {
        this.lifecycle?.begin(action);
        return this.lifecycle === undefined
            ? await operation()
            : await this.lifecycle.runExclusive(operation);
    }
}
function exactRecord(value, expectedFields) {
    if (typeof value !== "object" || value === null || Array.isArray(value)) {
        throw new TypeError("Expected command payload object");
    }
    const actualFields = Object.keys(value).sort();
    const expected = [...expectedFields].sort();
    if (actualFields.some((field) => !expected.includes(field))) {
        throw new TypeError("Unexpected command payload fields");
    }
    return value;
}
function stringField(value, field) {
    const candidate = value[field];
    if (typeof candidate !== "string" || candidate.trim() === "")
        throw new TypeError(`Expected ${field}`);
    return candidate;
}
function json(value) {
    return JSON.parse(JSON.stringify(value));
}
//# sourceMappingURL=storage-recovery-command-dispatcher.js.map